import React from 'react';

import { money as moneyFormat } from 'utils/format/money';
import policy_invoice_statuses from 'data/policy_invoice_statuses';
import Actions from './Actions';

const statusHuman = (value) => policy_invoice_statuses.find((item) => item.value == value).label;

const columns = [
  {
    name: 'Date',
    selector: (row) => row.attributes.invoice_date_formatted,
    sortable: true,
  },
  {
    name: 'Enterprise',
    selector: (row) => row.attributes.enterprise,
    sortable: true,
  },
  {
    name: 'Invoice Number',
    selector: (row) => row.attributes.invoice_number,
    sortable: true,
    cell: (row) => row.attributes.invoice_number,
  },
  {
    name: 'Payment Method',
    selector: (row) => row.attributes.payment_method,
    sortable: true,
    cell: (row) => row.attributes.payment_method,
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    sortable: true,
    cell: (row) => statusHuman(row.attributes.status),
  },
  {
    name: 'Amount',
    selector: (row) => row.attributes.amount,
    sortable: true,
    cell: (row) => moneyFormat(row.attributes.amount, row.attributes.currency.title),
  },
  {
    name: 'Actions',
    sortable: false,
    width: '140px',
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
